import { StoryView } from '@/pages/StoryView'

/**
 * A story (/app/story/:id), Brian's after/article.html v2.6. The id is a built
 * story's, or a feed card's headline id: a story not built yet opens as a
 * preview with Build this story · 12. StoryView declares its own chrome, since
 * its toolbar action (Build, or Send to phone on desktop) depends on the story.
 */
export function StoryPage() {
  return <StoryView />
}
